import {Component, EventEmitter, Host, OnDestroy, OnInit} from '@angular/core';
import {ApiResidentService} from '../../../services/api-directory.service';
import {DirectoryItemComponent} from '../directory-item.component';
import {AbstractView} from '../abstract-view.class';
import {PhoneTransformer} from '../../../services/transformer.service';
import {DirectoryService} from '../../../services/directory.service';
import {UserService} from '../../admin/user/services/user.service';
import {Http, RequestOptions, Headers, Response} from '@angular/http';
import { environment } from 'environments/environment';
import {Resident} from '../../../types/models';
import {ParkingPassService} from 'app/services/parking-pass.service';
import {AmenitiesService} from '../../../services/amenities.service';
import {ApiClientService} from '../../../services/api-client.service';
import {Router} from '@angular/router';
import { AuthTokenService } from '../../../services/auth-token.service';

declare const swal: any;
declare const toastr: any;

@Component({
    templateUrl: 'residents.template.html',
    providers: [ApiResidentService]
})
export class ResidentsComponent extends AbstractView implements OnInit, OnDestroy {
    title = 'Resident';
    refreshData: EventEmitter<any> = new EventEmitter();
    spinnerAvatar = false;
    avatarUploadDisabled = false;
    showInstructionsHistory = false;

    constructor(
      @Host() parent: DirectoryItemComponent,
      public directoryService: DirectoryService,
      public api: ApiResidentService,
      public apiClient: ApiClientService,
      public userService: UserService,
      public http: Http,
      public amenitiesService: AmenitiesService,
      public parkingPassService: ParkingPassService,
      private authTokenService: AuthTokenService,
      public router: Router,
    ) {
        super(parent, api);
        this.refreshData.subscribe(() => {
            super.ngOnInit();
            this.updateView();
        });
    }

    ngOnInit() {
        this.parent.directoryService.getGroups();
        if(Object.keys(this.parent.directoryService.urlService.queryParams).length < 1)
            this.parent.directoryService.urlService.queryParams = this.parent.directoryService.urlService.getQueryParamsJson();

        const urlTree = this.parent.router.createUrlTree(
            [],
            {queryParams: this.directoryService.urlService.queryParams, skipLocationChange: true});
        this.parent.router.navigateByUrl(urlTree);
        this.directoryService.imageCaptured.subscribe(image => this.changeAvatar({target: {files: [image]}}));

        super.ngOnInit();
    }

    getPrimaryPhone(data: Array<any>): string | boolean {
        if (data && data.length) {
            const primaryPhone = data.find(item => item.isPrimaryPhone);

            if (primaryPhone) {
                if(primaryPhone.phone.match('^[0-9]+$'))
                    return PhoneTransformer.stringToPhone(primaryPhone.phone);
                else
                    return primaryPhone.phone.substr();
            }
        }

        return false;
    }

    resetPhones(phones) {
        this.data.phones = phones;
    }

    resetAddress(addresses) {
        this.data.addresses = addresses;
    }

    remove(): void {
        swal({
                title: 'Move Out Resident',
                text: 'Are you sure you want to move out resident?',
                type: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#DD6B55',
                confirmButtonText: 'Yes',
                cancelButtonText: 'No',
                closeOnConfirm: true
            }, () => {
                this.api.deleteItem(this.id).subscribe(() => {
                    this.updateView();
                });
            }
        );

    }

    updateUserRoleInList(id: number, value: string): void {
        const item = this.parent.residentsList.find(item => item.id === id);
        if (item) item.suiteUser[0].role = value;
    }

    sendInvitation(isInvitation): void {
        const resident = this.data;

        const suiteUser = this.data.suiteUser[0];

        const newResident = new Resident();
        newResident.id = resident.id;
        newResident.suiteUserId = suiteUser.id;
        newResident.isValidEmail = resident.isValidEmail;
        if (resident.email)                   newResident.email                   = resident.email;
        if (resident.alternativeEmails)       newResident.alternativeEmails       = resident.alternativeEmails;
        if (resident.photo)                   newResident.photo                   = resident.photo;
        if (resident.fullName)                newResident.fullName                = resident.fullName;
        if (suiteUser.occupancyDate)          newResident.occupancyDate           = suiteUser.occupancyDate;
        if (suiteUser.moveOutDate)            newResident.moveOutDate             = suiteUser.moveOutDate;
        if (resident.dateOfBirth)             newResident.dateOfBirth             = resident.dateOfBirth;
        if (resident.emergencyContact)        newResident.emergencyContact        = resident.emergencyContact;
        if (resident.emergencyAssistantNotes) newResident.emergencyAssistantNotes = resident.emergencyAssistantNotes;
        if (resident.note)                    newResident.note                    = resident.note;
        if (suiteUser.role)                   newResident.role                    = suiteUser.role;
        if (resident.emailWaiverSigned)       newResident.emailWaiverSigned       = resident.emailWaiverSigned ? 1 : 0;
        if (resident.parcelWaiverSigned)      newResident.parcelWaiverSigned      = resident.parcelWaiverSigned ? 1 : 0;
        if (resident.keyWaiverSigned)         newResident.keyWaiverSigned         = resident.keyWaiverSigned ? 1 : 0;
        if (resident.maxTvUser)               newResident.maxTvUser               = resident.maxTvUser ? 1 : 0;
        if (resident.oauthId)                 newResident.oauthId                 = resident.oauthId;

        if (suiteUser.suite)                  newResident.suiteId                 = suiteUser.suite.id;
        if (suiteUser.suite)                  newResident.suiteNumber             = suiteUser.suite.suiteNumber;
        if (suiteUser.suite)                  newResident.commonElementsFee       = suiteUser.suite.commonElementsFee;
        if (suiteUser.building)               newResident.buildingId              = suiteUser.building.id;
        if (suiteUser.building)               newResident.buildingName            = suiteUser.building.name;
        if (suiteUser.building)               newResident.buildingAddress         = suiteUser.building.address;
        if (suiteUser.building)               newResident.corporationNumber       = suiteUser.building.corporationNumber;

        this.directoryService.sendInvitationToTheResident(newResident, this.parent.suiteData.building.corporationNumber, isInvitation);
    }

    moveResidentOut(data) {
        this.directoryService.moveOutFormResident = {
            id: data.user,
            suiteId: this.parent.suiteData.id,
            suiteNumber: this.parent.suiteData.suiteNumber,
            refreshEmitter: this.refreshData
        };
        this.directoryService.showMoveOutModal = true;
    }

    resetPassword(data) {
        this.directoryService.showResetPasswordModal = true;
        this.userService.userInResetPasswordModal = JSON.parse(JSON.stringify(data));
        //Needed for proper work in the modal
        this.userService.userInResetPasswordModal.id = this.userService.userInResetPasswordModal.oauthId;
    }

    changeAvatar(e) {
        this.spinnerAvatar = true;
        const file = e.target.files[0];
        const fd = new FormData();
        e.target.value = null;

        fd.append('fileUpload', file);
        fd.append('_format', 'json');

        const token = this.authTokenService.accessToken;
        const headers = new Headers({'Authorization': `Bearer ${token}`});
        const options = new RequestOptions({headers: headers});

        this.http.post(`${environment.domainEmails}/_uploader/attachments/upload`, fd, options)
            .map((response: Response) => response.json()).subscribe(
            res => {
                if (!res.path) {
                    toastr.warning('File path should not be blank.');
                    return;
                }
                this.data.photo = res.path;
                this.update({photo: this.data.photo});
                this.spinnerAvatar = false;
            },
            error => {
                this.directoryService.api.errorHandler(error, 'Upload file failed');
                this.spinnerAvatar = false;
            }
        );
    }

    removeAvatar() {
        this.data.photo = '';
        this.update({photo: this.data.photo});
    }

    addInstructions(type) {
        this.directoryService.instructionsModalUser = this.data.id;
        this.directoryService.showAddInstructionsModal = true;
        this.directoryService.instructionsModalType = type == 'entry' ? 'entry_instruction' : 'vacation_instruction';
    }

    bookAmenityForResident(data) {
        const preparedData = {
            buildingId: data.building.id,
            buildingName: data.building.name,
            buildingTimezone: data.building.timeZone ? data.building.timeZone.value : '',
            suiteId: data.suiteUser[0].suite.id,
            suiteNumber: data.suiteUser[0].suite.suiteNumber,
            id: data.id,
            fullName: data.fullName
        };
        this.directoryService.bookAmenityForResident(preparedData);
    }

    createParkingPassForResident(data) {
        const preparedData = {
            buildingId: data.building.id,
            buildingName: data.building.name,
            suiteId: data.suiteUser[0].suite.id,
            suiteNumber: data.suiteUser[0].suite.suiteNumber,
            id: data.id,
            fullName: data.fullName
        };
        this.directoryService.createParkingPassForResident(preparedData);
    }

    showInstructionsHistoryTrigger(show) {
        this.showInstructionsHistory = show;
        this.directoryService.selectedResidentInstructions.forEach(i => {
            i.visible = !!show;
        });
    }

    numberOfCurrentInstructions() {
        return this.directoryService.selectedResidentInstructions.filter(i => i.visible).length;
    }

    editInstruction(instruction) {
        this.directoryService.instructionsModalUser = this.data.id;
        this.directoryService.showAddInstructionsModal = true;
        this.directoryService.instructionsModalType = instruction.type;
        this.directoryService.instructionInInstructionsModal = instruction;
    }

    arrayFieldsSubmit(fieldName, data) {
        const formatted = {};
        const otherResidentField = this.data.suiteUser[0].suite[fieldName].filter(item => !data[fieldName].find(i => i.id == item.id) && item.user != this.data.id);
        data[fieldName] = data[fieldName].concat(otherResidentField);
        formatted[fieldName] = data[fieldName].map(item => ({
            user: (item.user || item.user === null) ? item.user : undefined,
            fieldValue: item.fieldValue
        }));
        const url = `/v1/suites/${this.data.suiteUser[0].suite.id}.json`;
        this.directoryService.api.patch('domainBD', url, formatted).subscribe(
            (res)   => this.updateView(),
            (error) => this.directoryService.api.errorHandler(error, 'Edit failed')
        );
    }

    clickConsentInput() {
        document.getElementById('fileInput').click();
    }

    public onFileInput(file): void {
        file.preventDefault();
        if(file.target.files && file.target.files.length) {
            for(let i = 0; i < file.target.files.length; i++) {
                this.addImage({target: { files: [file.target.files[i]] } });
            }
        }
    }

    addImage(e) {
        const file = e.target.files[0];
        const fd = new FormData();
        e.target.value = null;

        if (file.size > 1000000) {
            toastr.warning('Maximum document size is 1MB.');
            return;
        }

        fd.append('fileUpload', file);
        fd.append('_format', 'json');

        const token = this.authTokenService.accessToken;
        const headers = new Headers({'Authorization': `Bearer ${token}`});
        const options = new RequestOptions({headers: headers});

        this.http.post(`${environment.domainAmenities}/_uploader/attachments/upload`, fd, options)
            .map((response: Response) => response.json()).subscribe(
            res => {
                if (!res.path) {
                    toastr.warning('Document path should not be blank.');
                    return;
                }
                this.uploadConsent(this.data.id, res.path, true);
            },
            error => this.apiClient.errorHandler(error, 'Upload file failed')
        );
    }

    uploadConsent(user, path, value) {
        if(value) {
            const data = {
                user: user,
                pathToPdf: path,
                isSigned: 1
            };
            const url = `/v1/consent.json`;
            this.apiClient.post('domainBD', url, data).subscribe(
                res => {
                    this.getData(this.data.id);
                    toastr.success('Consent has been uploaded successfully');
                }, error => this.apiClient.errorHandler(error, 'Failed to save electronic signature consent.')
            );
        } else {
            const url = `/v1/consent/${this.data.consent.id}.json`;
            this.apiClient.remove('domainBD', url).subscribe(
                res => {
                    this.getData(this.data.id);
                    toastr.success('Consent has been deleted successfully');
                }, error => this.apiClient.errorHandler(error, 'Failed to remove electronic signature consent.')
            );
        }
    }

    takeImageFromWebcam(event) {
        event.stopPropagation();
        this.directoryService.showImageCaptureModal = true;
    }

    ngOnDestroy() {
        this.directoryService.imageCaptured.observers = [];
        super.ngOnDestroy();
    }
}



// WEBPACK FOOTER //
// /app/src/app/views/directory-item/residents/residents.component.ts